import {
  ArticlesMessage as ArticlesMessageType,
  Conversation,
} from '@stripe-internal/conversations-client';
import {view} from '@sail/ui';
import {ReactNode} from 'react';
import {ChatRow} from '../../../Chat';
import {ArticlesMessage} from './ArticlesMessage';
import {ArticleSourcesDropdown} from './ArticleSourcesDropdown';

type Props = {
  conversation: Conversation;
  message: ArticlesMessageType;
  avatar?: ReactNode | null;
};

export const ArticlesMessageRow = ({conversation, message, avatar}: Props) => {
  if (message.articleStyle === 'sources_dropdown') {
    return (
      <view.div data-testid="articles-message-sources-dropdown-row">
        <ChatRow avatar={avatar}>
          <ArticleSourcesDropdown
            conversation={conversation}
            articles={message.articles}
          />
        </ChatRow>
      </view.div>
    );
  } else {
    return (
      <view.div data-testid="articles-message-row">
        <ChatRow avatar={avatar}>
          <ArticlesMessage conversation={conversation} message={message} />
        </ChatRow>
      </view.div>
    );
  }
};
